<template>
  <ContainerWrapper>
    <OffersList
      title="Com imóvel em garantia"
      :offer-list="cptdHomeEquityOffers"
    >
      <template #start-offers>
        <FlowCrediOfferCardContainer key="FLOWCREDI" />
      </template>

      <ConexaoFinanceiraOfferCardContainer
        v-if="cptdDisplayConexaoFinanceira"
        key="CONEXAO_FINANCEIRA"
      />

      <template v-if="displayFakeOffers">
        <ProductEmptyStateOfferCard
          v-for="offer in cptdEmptyStateOffers"
          :key="offer.amount"
          :amount="offer.amount"
          :duration="offer.duration"
          :interest-rate="offer.interestRate"
          product="HOME_EQUITY"
          form-path="/forms/emprestimo/home-equity/simular"
        />
      </template>
    </OffersList>
    <HomeEquityColdOfferNoResultFeedbackDialogContainer
      v-if="displayHomeEquityNoResultFeedbackDialog"
      :display="displayHomeEquityNoResultFeedbackDialog"
      @close="displayHomeEquityNoResultFeedbackDialog = false"
    />
  </ContainerWrapper>
</template>
<script>
import { mapGetters } from 'vuex'
import ContainerWrapper from '@/components/ui/newComponents/ContainerWrapper.vue'
import OffersList from '@/components/appForm/loanResults/OffersList.vue'
import HomeEquityColdOfferNoResultFeedbackDialogContainer from '@/containers/forms/loans/home-equity/cold-offer/HomeEquityColdOfferNoResultFeedbackDialogContainer.vue'
import ProductEmptyStateOfferCard from '@/components/loans/ProductEmptyStateOfferCard.vue'
import { isDateLowerThan, localDate } from '@/helpers/date'
import ConexaoFinanceiraOfferCardContainer from '@/containers/loans/home-equity/offer/affiliates/conexao-financeira/ConexaoFinanceiraOfferCardContainer.vue'
import { getHomeEquityAffiliates } from '@/helpers/loans/home-equity/affiliates'
import { OfferStatus, Partner } from '@/data/common'
import FlowCrediOfferCardContainer from '@/containers/loans/home-equity/offer/affiliates/flowcredi/FlowCrediOfferCardContainer.vue'
export default {
  name: 'HomeEquityOffersListContainer',
  components: {
    FlowCrediOfferCardContainer,
    ConexaoFinanceiraOfferCardContainer,
    ProductEmptyStateOfferCard,
    ContainerWrapper,
    OffersList,
    HomeEquityColdOfferNoResultFeedbackDialogContainer,
  },
  data() {
    return {
      displayHomeEquityNoResultFeedbackDialog: false,
      displayFakeOffers: false,
    }
  },
  computed: {
    ...mapGetters({
      gtCreditScoreLatest:
        'products/credit-score/credit-score/gtCreditScoreLatest',
      gtHomeEquityColdOffers:
        'products/loans/home-equity/cold-offer/gtHomeEquityColdOffers',
      gtHomeEquityLatestColdOfferRequest:
        'products/loans/home-equity/cold-offer/gtHomeEquityLatestColdOfferRequest',
      gtAllValidatingHomeEquityOffers:
        'products/loans/home-equity/home-equity/gtAllValidatingHomeEquityOffers',
      gtAllProposedHomeEquityOffers:
        'products/loans/home-equity/home-equity/gtAllProposedHomeEquityOffers',
      gtHomeEquityExtraQuestions:
        'products/loans/home-equity/cold-offer/gtHomeEquityExtraQuestions',
    }),
    cptdHomeEquityOffers() {
      return [
        ...this.gtAllProposedHomeEquityOffers,
        ...this.gtAllValidatingHomeEquityOffers,
        ...this.gtHomeEquityColdOffers,
      ]?.filter((offer) => {
        if (
          offer?.partner === Partner.CREDIHOME &&
          offer.status === OfferStatus.PROPOSED
        ) {
          return (
            this?.gtCreditScoreLatest?.data?.score > 500 &&
            (this?.gtHomeEquityExtraQuestions?.collateral_type ===
              'Residencial' ||
              this?.gtHomeEquityExtraQuestions?.collateral_type ===
                'Comercial' ||
              this?.gtHomeEquityExtraQuestions?.collateral_type ===
                'Terreno dentro de condomínio')
          )
        }

        return true
      })
    },
    cptdDisplayOffers() {
      return (
        this.cptdHomeEquityOffers.length > 0 ||
        this.cptdDisplayAffiliates ||
        this.displayFakeOffers
      )
    },
    cptdEmptyStateOffers() {
      return [
        {
          amount: 150000,
          duration: 360,
          interestRate: 0.99,
        },
        {
          amount: 100000,
          duration: 360,
          interestRate: 0.99,
        },
        {
          amount: 50000,
          duration: 360,
          interestRate: 0.99,
        },
      ]
    },
    cptdDisplayFlowCredi() {
      return this.cptdAvailableAffiliates[Partner.FLOWCREDI]
    },
    cptdDisplayConexaoFinanceira() {
      return this.cptdAvailableAffiliates[Partner.CONEXAO_FINANCEIRA]
    },
    cptdDisplayAffiliates() {
      return this.cptdDisplayFlowCredi || this.cptdDisplayConexaoFinanceira
    },
    cptdAvailableAffiliates() {
      return getHomeEquityAffiliates(
        this.gtHomeEquityLatestColdOfferRequest,
        this.gtHomeEquityExtraQuestions,
        this.gtCreditScoreLatest?.data?.score || 0,
      )
    },
  },
  mounted() {
    if (
      this.cptdHomeEquityOffers.length === 0 &&
      !this.cptdAvailableAffiliates
    ) {
      this.displayFakeOffers =
        !Object.keys(this.gtHomeEquityLatestColdOfferRequest || {}).length ||
        (this.gtHomeEquityLatestColdOfferRequest?.created &&
          isDateLowerThan(
            localDate(this.gtHomeEquityLatestColdOfferRequest?.created),
            new Date(Date.now() - 24 * 60 * 60 * 1000 * 30),
          ))
    }

    this.checkLastSimulationResult()
  },
  methods: {
    checkLastSimulationResult() {
      const { last_product_simulation } = this.$route?.query || {}
      this.displayHomeEquityNoResultFeedbackDialog =
        last_product_simulation === 'home-equity' &&
        this.cptdHomeEquityOffers.length === 0 &&
        !this.cptdDisplayAffiliates
    },
  },
}
</script>
<style lang="scss"></style>
